'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _JSON$stringify = require('@babel/runtime-corejs3/core-js-stable/json/stringify');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _JSON$stringify__default = /*#__PURE__*/_interopDefaultLegacy(_JSON$stringify);

/**
 * Vertex style json representation in database.
 *
 * @export
 * @interface DBVertexStyleJson
 */

/**
 * VertexStyle describes the style of a vertex type, including it's color,
 * coordinates, etc.
 *
 * @export
 * @class VertexStyle
 */
var VertexStyle = /*#__PURE__*/function () {
  /**
   * Creates an instance of VertexStyle.
   *
   * @memberof VertexStyle
   */
  function VertexStyle() {
    _classCallCheck__default["default"](this, VertexStyle);
    this.fillColor = this.x = this.y = this.icon = undefined;
    this.other = {};
  }

  /**
   * Clone vertex style.
   *
   * @returns {VertexStyle}
   * @memberof VertexStyle
   */
  return _createClass__default["default"](VertexStyle, [{
    key: "clone",
    value: function clone() {
      var vertexStyle = new VertexStyle();
      vertexStyle.fillColor = this.fillColor;
      vertexStyle.x = this.x;
      vertexStyle.y = this.y;
      vertexStyle.icon = this.icon;
      if (this.other) {
        vertexStyle.other = JSON.parse(_JSON$stringify__default["default"](this.other));
      } else {
        vertexStyle.other = {};
      }
      return vertexStyle;
    }

    /**
     * Set properties from DB vertex style json.
     *
     * @param {DBVertexStyleJson} vertexStyle
     * @returns {VertexStyle}
     * @memberof VertexStyle
     */
  }, {
    key: "loadFromDBJson",
    value: function loadFromDBJson(vertexStyle) {
      this.fillColor = vertexStyle.fillColor;
      this.x = vertexStyle.x;
      this.y = vertexStyle.y;
      this.icon = vertexStyle.icon;
      this.other = vertexStyle.other;
      return this;
    }

    /**
     * Dump VertexStyle into DB vertex style json representation.
     *
     * @returns {DBVertexStyleJson}
     * @memberof VertexStyle
     */
  }, {
    key: "dumpToDBJson",
    value: function dumpToDBJson() {
      return this.icon ? {
        fillColor: this.fillColor,
        x: this.x,
        y: this.y,
        icon: this.icon,
        other: this.other
      } : {
        fillColor: this.fillColor,
        x: this.x,
        y: this.y,
        other: this.other
      };
    }
  }]);
}();

exports.VertexStyle = VertexStyle;
